/* eslint-disable */
export const oidcConfig_os = {
  authority: process.env.REACT_APP_OS_AUTHORITY,
  client_id: process.env.REACT_APP_OS_CLIENT_ID,
  client_secret: process.env.REACT_APP_OS_CLIENT_SECRET,
  redirect_uri: process.env.REACT_APP_OS_REDIRECT_ORIGIN,
  post_logout_redirect_uri: process.env.REACT_APP_OS_REDIRECT_ORIGIN,
  automaticSilentRenew: true,
  scope: "openid rights profile email modules"
};


export const oidcConfig_ms = {
  authority: process.env.REACT_APP_MS_AUTHORITY,
  client_id: process.env.REACT_APP_MS_CLIENT_ID,
  client_secret: process.env.REACT_APP_MS_CLIENT_SECRET,
  redirect_uri: process.env.REACT_APP_MS_REDIRECT_ORIGIN,
  post_logout_redirect_uri: process.env.REACT_APP_MS_REDIRECT_ORIGIN,
  automaticSilentRenew: true,
  scope: "openid rights profile email modules"
};
